<template>
  <div class="spinner spinner--show">
    <div class="spinner__graphic"></div>
  </div>
</template>

<script>
export default {
  name: "Spinner-mm",
};
</script>
